import * as service from './Performance.service'
export default {
  data() {

    return {
      //FG - FOOF - temp vars below
      iamediting: false,
      iamadding: false,
      iamviewing: false,
      action: "", //FG - FOOF - After Cert - First Release Security (7) - added action variable

      //FG - FOOF - temp vars above

      Kudoscolumnsq: ['ActionDate', 'Type', 'WroteBy', 'Actions'],
      optionstable: {
        skin: this.$hydrowareCommonJS.hydrowareTableSkin,
        headings: {
          ActionDate: 'Date',
          Type: 'Type',
          WroteBy: 'Reported By',

          Actions: ''
        },
        labelPosition: 'top',
        isediting: false,
        EditableColID: '',
        role: '',

        sortIcon: {base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down'},
        perPage: 10,
        perPageValues: [5, 10, 25, 50, 100],
        sortable: ['ActionDate'],
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },
      performances: [],
      perfbackup: [],
      typeFilter: '',
      ptypes: [],
      role: '',
      disci: false,
      isediting: false,
      evalu: false,
      kudo: false,
      modalTitle: '',
      isself: false,//FG - FOOF - After Cert - First Release Security
    }
  },
  mounted() {
    let context = this
    this.personnelID = this.$route.params.id
    //FG - FOOF - After Cert - First Release Security - added line below
    this.isself = (this.personnelID == JSON.parse(localStorage.getItem('authentication')).PersonnelId) ? true : false

    this.role = JSON.parse(localStorage.getItem('authentication')).role
    this.ptypes = [{
      label: 'All',
      value: 0

    }, {
      label: 'Kudos',
      value: 1
    },
      {
        label: 'Evaluation',
        value: 2
      },
      {
        label: 'Discipline',
        value: 3
      }
    ]
    this.typeFilter = 0
    this.GetPerformance(this.personnelID)

    this.$router.app.$on('action_done', (data) => {
      $('#Addperfomodel').modal('hide')
      context.GetPerformance(this.personnelID)
      context.disci = false
      context.kudo = false
      context.evalu = false
    })

  },
  beforeDestroy () {

    this.$root.$off('action_done')

  },
  methods: {
    cancelpopup()
    {
      $('#Addperfomodel').modal('hide')
    },
    del(prop)
    {
      let data = prop.row
      let context = this
      if (data.Type == 'Kudos') {
        this.evalu = false
        this.disci = false
        this.kudo = true
        setTimeout(function () {
          context.$router.app.$emit('del_kudos', data.TypeId)
        })
      }
      if (data.Type == 'Discipline') {
        this.evalu = false
        this.disci = true
        this.kudo = false
        setTimeout(function () {
          context.$router.app.$emit('del_disci', data.TypeId)
        })
      }
      if (data.Type == 'Evaluation') {
        this.evalu = true
        this.disci = false
        this.kudo = false
        setTimeout(function () {
          context.$router.app.$emit('del_eval', data.TypeId)
        }, 100)
      }

    },

    editcol(prop,buttonType)
    {
      //FG - FOOF - After Cert - First Release Security (7) - added the conditional stmt below to set action
      var firstWordInTitle = "View"
      if(buttonType=="view") {
        this.action="V"
      }
      else {
        this.action="E"        
      }
      
      let data = prop.row
      this.isediting = true

this.iamviewing=true;
this.iamediting=false;
this.iamadding=false;

      let context = this
      if (data.Type == 'Kudos') {
        this.modalTitle = firstWordInTitle + ' Kudos'
        this.evalu = false
        this.disci = false
        this.kudo = true
        $('#Addperfomodel').modal('show')
        setTimeout(function () {
          context.$router.app.$emit('kudos_obj', data.TypeId)
        }, 100)

      }

      if (data.Type == 'Discipline') {
        this.modalTitle = firstWordInTitle + ' Discipline'
        this.evalu = false
        this.disci = true
        this.kudo = false
        $('#Addperfomodel').modal('show')
        setTimeout(function () {
          context.$router.app.$emit('Discipline_obj', data.TypeId)
        }, 100)

      }
      if (data.Type == 'Evaluation') {
        this.modalTitle = firstWordInTitle + ' Evaluation'
        this.evalu = true
        this.disci = false
        this.kudo = false
        $('#Addperfomodel').modal('show')
        setTimeout(function () {
          context.$router.app.$emit('Evaluation_obj', data.TypeId)
        }, 100)

      }

    },

    ShowAddKudos()
    {
      let context = this
      this.action = "A";//FG - FOOF - After Cert - First Release Security (7) - set action to 'A' when adding
      context.iamviewing=true;
      this.modalTitle = 'Create Kudos'
      this.kudo = true
      this.evalu = false
      this.disci = false
      $('#Addperfomodel').modal('show')
      //this.isediting = false
      setTimeout(function () {
        context.$router.app.$emit('add_kudos')
      }, 100)
    },
    ShowAddEvaluation()
    {
      let context = this
      this.action = "A";//FG - FOOF - After Cert - First Release Security (7) - set action to 'A' when adding
      this.modalTitle = 'Create Evaluation'
      this.isediting = false
      this.evalu = true
      this.disci = false
      this.kudo = false
      $('#Addperfomodel').modal('show')
      setTimeout(function () {
        context.$router.app.$emit('add_eval')
      }, 100)
    },
    showDiscipline()
    {
      let context = this
      this.action = "A";//FG - FOOF - After Cert - First Release Security (7) - set action to 'A' when adding
      this.modalTitle = 'Create Discipline'
      this.isediting = false
      this.disci = true
      this.kudo = false
      this.evalu = false
      $('#Addperfomodel').modal('show')
      setTimeout(function () {
        context.$router.app.$emit('add_dis')
      }, 100)
    },
    submitForm()
    {
      if (this.kudo == true) {
        this.$router.app.$emit('submit_kudos', 'addKudos')
      }
      if (this.disci == true) {
        this.$router.app.$emit('submit_disci', 'DisciplineForm')
      }
      if (this.evalu == true) {
        this.$router.app.$emit('submit_eval', 'addEvaluation')
      }
    },
    updateForm()
    {
      if (this.kudo == true) {

        this.$router.app.$emit('update_kudos', 'addKudos')
      }
      if (this.disci == true) {
        this.$router.app.$emit('update_disci', 'DisciplineForm')
      }
      if (this.evalu == true) {
        this.$router.app.$emit('update_eval', 'addEvaluation')
      }

    },
    cFilter()
    {
      let context = this
      this.performances = this.perfbackup
      switch (this.typeFilter) {

        case 0 :
          this.performances = this.perfbackup
          break
        case 1:
          var pk = []
          this.performances.map(function (item, index) {
            if (item.Type == 'Kudos') {
              pk.push(item)
            }

          })
          this.performances = pk
          break

        case 2:

          var pe = []
          this.performances.map(function (item, index) {
            if (item.Type == 'Evaluation') {
              pe.push(item)
            }

          })

          this.performances = pe
          break

        case 3:
          var pd = []
          this.performances.map(function (item, index) {
            if (item.Type == 'Discipline') {
              pd.push(item)
            }

          })
          this.performances = pd
          break

      }

    },

    GetPerformance(PersonnelId) {
      let context = this
      loader.startLoader()
      service.GetPerformance(PersonnelId).then(function (response) {
        context.perfbackup = deepcopy(response)
        context.performances = response

        context.$refs.dragtable.setPage(1)
        if (response) {
          tooltip.startTooltip(50)

        } else {
          context.performances = []
        }

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

  }
}



// WEBPACK FOOTER //
// ./src/components/Performance/Performance.controller.js